import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import { HttpStatusCodes } from '../../util/uiconstants';

export default function eventReducer(state = initialState.events, action) {
	switch (action.type) {
		case types.GET_CALENDER_EVENTS: {
			let events = [...action.response];

			return events;
		}
		case types.ADD_CALENDAR_EVENT: {
			if (action.responseObj.status == HttpStatusCodes.Ok) {
				let tempState = _.cloneDeep(state);
				if (tempState?.length > 0 && action.response) {
					console.log(tempState)
					tempState[0].timePhases.push(action.response);
					return tempState;
				} else if (tempState?.length === 0 && action.response) {
					// prepare a tempState when theres no events
					let timephase = [];
					let timePhases = [];

					timephase.push({
						id: null,
						timePhaseTypeName: null,
						timePhases
					})

					timephase[0]?.timePhases.push(action.response);
					tempState = timephase;

					return tempState;
				}
			}
			return state;
		}
		case types.EDIT_CALENDAR_EVENT: {
			if (action.responseObj.status == HttpStatusCodes.Ok) {
				let tempState = _.cloneDeep(state);
				if (tempState?.length > 0 && action.response) {

					let eventToReplace = tempState[tempState.findIndex(x => x.id === null)].timePhases.find(x => x.id === action.response.id);

					let updatedEvent = {
						dueDate: action.response.dueDate,
						engagementId: action.response.engagementId,
						entityID: action.response.entityID,
						id: action.response.id,
						isKeyEvent: action.response.isKeyEvent,
						periodName: action.response.periodName,
						startDate: action.response.startDate,
						syncStatusID: action.response.syncStatusID,
						timePhaseTypeId: action.response.timePhaseTypeId,
						timephaseDescription: action.response.timephaseDescription
					}

					let index = tempState[tempState.findIndex(x => x.id === null)].timePhases.findIndex(x => x.id === action.response.id);
					tempState[tempState.findIndex(x => x.id === null)].timePhases[index] = updatedEvent;

					return tempState;
				}
			}

			return state;
		}
		case types.DELETE_EVENT: {
			if (action.responseObj && action.responseObj.status === 200) {
				let newState = _.cloneDeep(state);
				newState[0].timePhases = newState[0].timePhases.filter((i) => i.id !== action.event.timephaseId);

				return newState;
			}

			return state;
		}

		default:
			return state;
	}
}
